var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"scroll-to-top rounded pointer",class:{ 'd-block': _vm.windowTop > 100 },on:{"click":function($event){return _vm.top()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'angle-up'],"fized-width":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }